import {
    AnimationLoadingBaseController,
    DragonBonesResourceItem,
    IAnimationControllerConfiguration,
    ILoadingBaseController
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {PreloaderBackgroundController} from "../Common/PreloaderBackgroundController";
import {AnimationContents} from "../AnimationContents";

export interface IPreloaderGameControllerOptions {
    test: string;
}

export class PreloaderGameController extends AnimationLoadingBaseController implements ILoadingBaseController
{
    public $model;

    public constructor(@Inject private _options: IPreloaderGameControllerOptions)
    {
        super("PreloaderGameController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.PRELOADER_SCREEN_JSON,
            libraryName: "preloader_screen",
            childControllers:{
                StreetBackgroundController:{
                    instanceName: "bg",
                    view: PreloaderBackgroundController
                }
            }
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(0);
    }

    protected onLandscape(): void {
        this.gotoAndStop("landscape");
    }

    protected onPortrait(): void {
        this.gotoAndStop("portrait");
    }

    protected onUpdate(frameRate: number): void {
    }

    public onLoadingProgress(progress: number): void {
        this.gotoAndStopByQuery("preloader_kykka", Math.floor(progress * 21));
    }

    public onHide(): void {
        this.gotoAndStopByQuery("preloader_kykka", 0);
    }

    public onShow(): void {

    }
}
